import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconBoltLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m10.55 18.2 5.175-6.2h-4l.725-5.675L7.825 13H11.3l-.75 5.2Zm-.973-3.7H6.535a.78.78 0 0 1-.739-.446.768.768 0 0 1 .058-.86l6.552-9.452a1.01 1.01 0 0 1 .515-.386.975.975 0 0 1 .652.017c.226.08.39.219.495.414.105.196.143.407.117.632l-.752 6.081h3.73c.357 0 .608.16.754.479.146.32.103.617-.129.892l-7.244 8.677a.984.984 0 0 1-.53.334.914.914 0 0 1-.612-.061 1.012 1.012 0 0 1-.462-.417.965.965 0 0 1-.124-.62l.761-5.284Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconBoltLine;
